require('./myProfileEditFrame.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ actions
const profile = require('actions/profile');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
const { ContactInfoBoxCCValidated: ContactInfoBox } = require('components/myProfile/contactInfoBox/contactInfoBox');
const ProfilePictureEditor = require('components/myProfile/profilePictureEditor/profilePictureEditor');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender');

// @ helpers
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname')

// @ constants
const boxTitle = formatText('profile-boxTitle');
const {
    PROC_CHANGE_PICTURE,
    PROC_START,
    recordProcess
} = require('utilities/tagging');
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');

class MyProfileEditFrame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleEditForm: false,
            toggleEditPicture: false,
        };
        this.onProfileEditSubmit = this.onProfileEditSubmit.bind(this);
        this.handlePictureEdit = this.handlePictureEdit.bind(this);
    }

    handlePictureEdit() {
        if (!this.state.toggleEditPicture) {
            recordProcess(PROC_CHANGE_PICTURE, PROC_START);
        }

        this.setState(prevState => ({
            toggleEditPicture: !prevState.toggleEditPicture
        }));
    }

    onProfileEditSubmit(value, preview, isAvatar) {
        const { updateProfilePicture } = this.props;

        this.setState({ toggleEditPicture: false });
        updateProfilePicture(value, preview, isAvatar);
    }

    buildFrame() {
        const {
            immProfileFields,
            innerContent,
            profileAvatarEditorModalShow,
            setProfileAvatarEditorError,
            setUserAlias,
        } = this.props;

        const boxBody = (
            <OKMessage type="important">
                <FormattedText value="profile-boxBody" />
            </OKMessage>
        );
        const leftColumnClassName = conditionalClassName('col-xs-12 col-md-8', 'profile-edit-view__left-column col-xs-12');
        const rightColumnClassName = conditionalClassName('col-xs-12 col-md-4', 'col-xs-12');

        return (
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="profile-edit-frame row grid-view--content-position-positive">
                        <div className={leftColumnClassName}>
                            <div className="row">
                                <div className="col-md-12">
                                    <ProfilePictureEditor
                                        editable={this.state.toggleEditPicture}
                                        fields={immProfileFields}
                                        handleSubmit={this.onProfileEditSubmit}
                                        onAliasChange={setUserAlias}
                                        onChangeModal={profileAvatarEditorModalShow}
                                        onClick={this.handlePictureEdit}
                                        setProfileAvatarEditorError={setProfileAvatarEditorError}
                                    />
                                </div>
                                <div className="col-md-12 grid-view--fix-cell-separation">
                                    {innerContent}
                                </div>
                            </div>
                        </div>
                        <div className={rightColumnClassName}>
                            <div className="row">
                                <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                                    <WebappRender>
                                        <ContactInfoBox
                                            boxBody={boxBody}
                                            boxTitle={boxTitle}
                                            hasMessage={true}
                                        />
                                    </WebappRender>
                                </div>
                                <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                    <CallMeBack pageTitle={formatText('profile-titleHeader')} hasEntrance={false}/>
                                </div>
                                <WebappRender>
                                    <div className="col-xs-12 grid-view--fix-cell-separation">
                                        <CommercialAds path="edit/shipping-address/:operation" type="banner-a" />
                                    </div>
                                </WebappRender>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildTutorial() {
        const { tutorialEnabled } = this.props;

        let dataToRender;

        if (tutorialEnabled) {
            dataToRender = (
                <TutorialLauncher
                    title={formatText('tutorials-profileDataTitle')}
                    type={GRAPHIC_TUTOR_TYPE_4}
                />
            );
        }

        return dataToRender;
    }

    render() {
        const frameBody = this.buildFrame();
        const tutorial = this.buildTutorial();
        const titleHeader = formatText('profile-titleHeader');

        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="small"
                            section="pg"
                            customClass="col-xs-12"
                        >
                            <OKHeaderLanding
                                title={titleHeader}
                                tutorial={tutorial}
                            />
                        </OKCover>
                    </div>
                </div>
                {frameBody}
            </React.Fragment>
        );
    }
}

MyProfileEditFrame.propTypes = {
    immProfileFields: PropTypes.object,
    innerContent: PropTypes.object.isRequired,
    profileAvatarEditorModalShow: PropTypes.func.isRequired,
    setProfileAvatarEditorError: PropTypes.func.isRequired,
    setUserAlias: PropTypes.func.isRequired,
    tutorialEnabled: PropTypes.bool,
    updateProfilePicture: PropTypes.func.isRequired,
};

MyProfileEditFrame.defaultProps = {
    tutorialEnabled: true,
}

module.exports.constructor = MyProfileEditFrame;
module.exports.MyProfileEditFrame = connect(
    state => ({
        immProfileFields: state.profile,
    }), {
    profileAvatarEditorModalShow: profile.profileAvatarEditorModalShow,
    setProfileAvatarEditorError: profile.setProfileAvatarEditorError,
    setUserAlias: profile.setUserAlias,
    updateProfilePicture: profile.updateProfilePicture,
})(MyProfileEditFrame);
